import { NetworkRegistry } from 'utils/networkRegistry'
import { GatewayInfo } from './chains'
import { MainnetChainIds, TestnetChainIds } from '../../constants/chains'
import { isMainnet } from '../../config'

// This is an abstruct interface, waiting for zklink to implement the actual scheduling system interface.
export async function getGatewayScheduling(gateways: GatewayInfo[]) {
  // For now, just only the Linea Gateway is available
  const lineaChainId = isMainnet
    ? MainnetChainIds.Linea
    : TestnetChainIds.LineaGoerli

  return gateways.find(
    (g) =>
      Number(g.chainId) ===
      Number(NetworkRegistry.byL1(lineaChainId)?.layerTwoChainId),
  )
}
